var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 25,
  fill: "none",
  viewBox: "0 0 26 25"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.189,
  cy: 10.534,
  r: 8.974,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3.024
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3.024,
  d: "m19.114 17.634 5.182 5.18"
})));
export default SvgSearch;